module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-screenShare_gray.76f9e48b.svg";